// @ts-nocheck
import { logError } from "./logger";

const STORAGE_KEY = "fourm_booking_tracking_tokens";
const MAX_HISTORY = 5;

export function getRecentTrackingTokens(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (token: unknown) => typeof token === "string" && token.trim()
    ) as string[];
  } catch (error) {
    logError("Failed to parse tracking tokens", error, "storage");
    return [];
  }
}

export function saveTrackingToken(token: string): void {
  if (typeof window === "undefined") return;
  const normalized = (token ?? "").trim();
  if (!normalized) return;

  const existing = getRecentTrackingTokens().filter(
    (value) => value !== normalized
  );
  existing.unshift(normalized);

  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(existing.slice(0, MAX_HISTORY))
    );
    if (
      typeof window !== "undefined" &&
      typeof window.dispatchEvent === "function"
    ) {
      window.dispatchEvent(new CustomEvent("fourm:tokens-updated"));
    }
  } catch (error) {
    logError("Failed to save tracking token", error, "storage");
  }
}
